"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionItem = void 0;
var _basketItem = require("@ori/basket-item");
var _useSectionItem = require("./useSectionItem");
var _jsxRuntime = require("react/jsx-runtime");
const SectionItem = ({
  item,
  sectionMiniBagProps,
  itemsX
}) => {
  const {
    basketItem
  } = (0, _useSectionItem.useSectionItem)({
    item,
    sectionMiniBagProps,
    itemsX
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_basketItem.BasketItem, {
    ...basketItem
  });
};
exports.SectionItem = SectionItem;
